<div bdFxLayout="row" class="ps-container">
    <div bdFxFlex="1 1 100%" class="ps-input-container">
        <input type="text"
               [disabled]="disabled"
               class="ps-value"
               [step]="step"
               lang="de_DE"
               [ngClass]="{'isError': showValidation && isError, 'ps-success': showValidation && !isError, 'icon-visible': showIcon}"
               [(ngModel)]="textValue"
               [name]="name"
               [placeholder]="placeholder || ''"
               (ngModelChange)="updateChanges(inputElement)"
               (blur)="onBlur(inputElement)"
               #inputElement/>
        <!--               (input)="filterInput($event, inputElement)"-->

        <div class="icon" (click)="onIconClicked()" *ngIf="showIcon">
            <ng-content></ng-content>
        </div>
    </div>
</div>

